import React from 'react';
import {useSelector} from 'react-redux';
import Loader from 'deprecated-shared-ui/templates/loader/default';
import {selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../LoaderSlice.jsx';
import {useBreakpointUp} from "bonprix-design-system";

export default function Loadingbar() {
    const breakpointLTUp = useBreakpointUp('l');
    const loader = useSelector(selectLoadingbarStatus);
    const filterLoader = useSelector(selectFilterLoadingbarStatus);
    if (loader.status || !breakpointLTUp && filterLoader.status) {
        return (
            <div className="article-overview__loader-wrapper article-overview__loading-area">
                {(loader.defaultCase || filterLoader.status) && <Loader className={"article-overview__loader"} />}
            </div>
        );
    } else {
        return <></>;
    }
}
